import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import {
  updateSiteContentRequest,
} from "../redux/slices/siteContentSlice";
import EditSaveButton from "./EditSaveButton";

// ---------- Constants ----------
const positionClasses: Record<
  "bottom-right" | "top-right" | "bottom-left" | "top-left",
  string
> = {
  "bottom-right": "fixed bottom-4 right-4",
  "top-right": "fixed top-4 right-4",
  "bottom-left": "fixed bottom-4 left-4",
  "top-left": "fixed top-4 left-4",
};

// ---------- Types ----------
interface FloatingActionButtonsProps {
  isEditMode: boolean;
  onEditToggle: () => void;
  disabled?: boolean;
  position?: "bottom-right" | "top-right" | "bottom-left" | "top-left";
  showBrandPicker?: boolean;
  showFontPicker?: boolean;
}

// ---------- Component ----------
const FloatingActionButtons: React.FC<FloatingActionButtonsProps> = ({
  isEditMode,
  onEditToggle,
  disabled = false,
  position = "bottom-right",
  showBrandPicker = true,
  showFontPicker = true,
}) => {
  const dispatch = useDispatch();
  const siteContent = useSelector((state: RootState) => state.siteContent.data);

  const handleSave = useCallback(() => {
    if (siteContent) {
      dispatch(updateSiteContentRequest());
    }
  }, [dispatch, siteContent]);

  return (
    <div className={`${positionClasses[position]} z-50 flex flex-col gap-3`}>
      {/* Edit Button */}
      <EditSaveButton
        isEditMode={isEditMode}
        onToggle={onEditToggle}
        disabled={disabled}
        position="relative"
        size="md"
        variant="red"
        ariaLabel={isEditMode ? "Save changes to page" : "Edit page content"}
      />

      {/* 
      TODO: Font and Color Picker UI - Commented out for clean implementation
      Font and color themes are now loaded automatically from siteContent JSON
      
      Font Picker UI code preserved here for future use:
      - Font selection modal with preview
      - Tailwind font class application
      - Redux theme state integration
      
      Color Picker UI code preserved here for future use:
      - Brand color selection with presets
      - Hex color input with validation
      - CSS variable injection via StyleProvider
      */}
    </div>
  );
};

export default React.memo(FloatingActionButtons);
